import styled from 'styled-components'
import { device } from '../../../../styles/GlobalVariables'

const StyledMuteIcon = styled.svg`
  width: 24px;
  aspect-ratio: 1;
  filter: drop-shadow(0px 0px 5px rgba(0, 0, 0, 0.6));

  ${device.medium} {
    width: 30px;
  }
`
export const Mute = () => {
  return (
    <StyledMuteIcon
      xmlns='http://www.w3.org/2000/svg'
      fill='none'
      viewBox='0 0 24 24'
    >
      <path
        fill='#fff'
        d='M2.408 4.274 6.128 8h-3.46a1.334 1.334 0 0 0-1.334 1.334v5.334A1.333 1.333 0 0 0 2.668 16h3.426l4.94 4.98a1.336 1.336 0 0 0 .966.354A1.334 1.334 0 0 0 13.334 20v-4.82l3.926 3.927a7.2 7.2 0 0 1-.5.28.668.668 0 0 0 .6 1.193q.45-.226.874-.5l1.52 1.52.914-.933L3.334 3.334zM12 20.001l-5.152-5.18a.664.664 0 0 0-.474-.153H2.668V9.334h3.76a.664.664 0 0 0 .473-.2l.174-.174 4.926 4.914zM16.594 4.459a8.28 8.28 0 0 1 2.74 12.94l.946.947a9.614 9.614 0 0 0-3.106-15.094.666.666 0 1 0-.58 1.2z'
      />
      <path
        fill='#fff'
        d='M15.126 8.414A4.184 4.184 0 0 1 17.199 12c0 .893-.29 1.76-.826 2.474l.96.946a5.44 5.44 0 0 0 1.2-3.42 5.52 5.52 0 0 0-2.734-4.74.666.666 0 1 0-.666 1.154zM12 4v6.1l1.334 1.334V4a1.334 1.334 0 0 0-2.28-.94L8 6.114l.94.94z'
      />
    </StyledMuteIcon>
  )
}
